// @flow

import type {ConfigFunction as MarkdocFunctionSchema} from '@markdoc/markdoc';

export const capitalize: MarkdocFunctionSchema = {
  render(parameters): string {
    const string = parameters['0'];

    return typeof string === 'string'
      ? string.charAt(0).toUpperCase() + string.slice(1)
      : string;
  },
};
